import type { CSSProperties } from 'react'
import { tacticPicked, type TacticCell } from '../../lib/signal-queue'

/**
 * The ATT&CK heat strip: one cell per tactic (attack/matrix skeleton), its
 * count from `cases/stats` top_tactics (top 10, whole scope — every other
 * tactic reads 0; docs/signals.md §ATT&CK heat strip), shaded by share of the
 * busiest cell. A click toggles the tactic in the Tactic filter; zero cells
 * stay visible, muted.
 */
export function HeatStrip({
  cells,
  picked,
  onToggle,
}: {
  cells: TacticCell[]
  picked: readonly string[]
  onToggle: (tactic: string) => void
}) {
  if (!cells.length) return null
  const max = Math.max(1, ...cells.map((c) => c.count))
  return (
    <div className="sg-heat" role="group" aria-label="ATT&CK tactics">
      {cells.map((c) => {
        const on = tacticPicked(picked, c.tactic)
        return (
          <button
            key={c.tactic}
            type="button"
            className="sg-heat-cell"
            aria-pressed={on}
            aria-label={`Tactic: ${c.tactic}, ${c.count} signal${c.count === 1 ? '' : 's'}`}
            title={`${c.tactic} · ${c.count}`}
            data-zero={c.count === 0 || undefined}
            style={{ '--sg-heat': `${c.count ? Math.round(12 + (68 * c.count) / max) : 0}%` } as CSSProperties}
            onClick={() => onToggle(c.tactic)}
          >
            <span className="sg-heat-name">{c.tactic}</span>
            <span className="sg-heat-n">{c.count}</span>
          </button>
        )
      })}
    </div>
  )
}
